// src/dashboard/widgets/ContinueCoursesWidget.tsx
//
// Thin wrapper around AICoursesSection. We own the white-card chrome and the
// heading/view-all link here so AICoursesSection can stay focused on rendering
// the course rows (vertical grid for /courses page, horizontal list for the
// dashboard surface).

import { AICoursesSection } from "@/shared/components/dashboard/AICoursesSection";
import { useT } from "@/shared/i18n/useT";
import { registerWidget } from "@/shared/dashboard/widgets/registry";
import type { WidgetProps } from "@/shared/dashboard/widgets/types";

function ContinueCoursesWidgetImpl(_: WidgetProps) {
  const t = useT();
  const heading = t("ui.continueCoursesWidget.heading");
  const viewAll = t("ui.continueCoursesWidget.viewAll");

  return (
    <section className="rounded-md border border-stone-200 bg-white p-5">
      <div className="mb-3 flex items-baseline justify-between">
        <h3 className="ed-serif text-base text-stone-900">{heading}</h3>
        <button
          onClick={() => (window as any).navigate?.("/courses")}
          className="min-h-11 cursor-pointer px-1 text-xs text-stone-500 transition-colors hover:text-stone-900 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1A4C53] focus-visible:ring-offset-2"
        >
          {viewAll}
        </button>
      </div>
      <AICoursesSection
        maxItems={2}
        onlyInProgress
        variant="horizontal"
        hideHeader
      />
    </section>
  );
}

registerWidget({
  id: "continueCourses",
  component: ContinueCoursesWidgetImpl,
  supportedSlots: new Set(["mainColumn", "sideRail"]),
  displayName: "Continue Learning",
});

export const ContinueCoursesWidget = ContinueCoursesWidgetImpl;
